import { v4 as uuidv4 } from 'uuid';

import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { SubmenuAccordion } from '../../../../vtex-apps/menu/SubmenuAccordion/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
const StoreMenuMobile = () => {
	return {
		componentName: 'Menu',
		componentGroup: 'StoreMenuMobile',
		componentId: uuidv4(),
		variables,
		props: Menu({ blockClass: 'menu-mob-3__menu', mzTitle: `MZ | Menu Mobile` }).props,
		childrenComponents: [...Array(7).keys()].map((menu) =>
			VisibilityLayout({ mzTitle: `MZ | Menu Mobile ${menu} (On/Off)` }, [
				MenuItem(
					{
						blockClass: 'menu-mob-3__menu-item',
						id: 'menu-item-category-mobile-3',
						type: 'custom',
						mzTitle: `MZ | Menu Mobile ${menu}`,
						itemProps: { categoryId: 10, text: `Coleção ${menu}`, itemType: 'category' },
					},
					[],
					[
						SubmenuAccordion({ blockClass: 'menu-mob-3__submenu' }, [
							Menu({
								blockClass: 'menu-mob-3__submenu',
								mzTitle: `MZ | subMenu Mobile ${menu}`,
								items: [...Array(7).keys()].map(
									(subMenu) =>
										MenuItem({
											id: `menu-item-category-home-${subMenu}`,
											mzTitle: `MZ | subMenu Mobile ${menu}.${subMenu}`,
										}).props,
								),
							}),
						]),
					],
				),
			]),
		),
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--menu-mob-3-menu-bg-color', name: 'Menu Background' },
			{ from: '--text-color-3-dark', to: '--menu-mob-3-menu-text-color', name: 'Menu Text' },
			{ from: '--neutral-color-high-medium', to: '--menu-mob-3-menuitem-bc', name: 'MenuItem Border' },
			{ from: '--text-color-3-dark', to: '--menu-mob-3-submenu-color', name: 'Submenu Text' },
			{ from: '--neutral-color-high-medium', to: '--menu-mob-3-submenu-bc', name: 'SubMenuItem Border' },
			{ from: '--neutral-color-high-medium', to: '--menu-mob-3-icon-bc', name: 'Icon' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-md', to: '--menu-mob-3-menu-fs', name: 'Menu' },
			{ from: '--font-size-sm', to: '--menu-mob-3-submenu-fs', name: 'Submenu Level' },
		],
	},
	{
		type: 'borderWidth',
		list: [
			{ from: '--border-width-hairline', to: '--menu-mob-3-menuitem-bw', name: 'MenuItem Border' },
			{ from: '--border-width-hairline', to: '--menu-mob-3-submenu-bw', name: 'Submenu Border' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--menu-mob-3-menu-fw', name: 'Menu' },
			{ from: '--font-weight-400', to: '--menu-mob-3-submenu-fw', name: 'Submenu' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-atom', to: '--menu-mob-3-menu-lateral-padding', name: 'Menuitem Lateral Padding' },
			{ from: '--spacing-nano', to: '--menu-mob-3-menu-line', name: 'Menu Items Line' },
			{ from: '--spacing-xxxs', to: '--menu-mob-3-submenu-lateral-padding', name: 'submenu Lateral Padding' },
			{ from: '--spacing-sm', to: '--menu-mob-3-submenu-line', name: 'submenu Line' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--menu-mob-3-menu-typography', name: 'Menu' },
			{ from: '--main-font', to: '--menu-mob-3-submenu-typography', name: 'Submenu' },
		],
	},
];

export default StoreMenuMobile;
